import React from "react";
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { Map } from 'immutable';
import Moment from 'react-moment';
import { Row, Col } from "shards-react";

import LoadingIndicator from '../common/loading-indicator';
import { practiceEfectoresActions, getCurrentPracticeEfectores } from "../../core/practice-efectores";
import { DEFAULT_SESSION_ID } from "../../core/constants";

class EfectoresList extends React.Component {

  componentWillMount() {
    const {  authenticated, user, data } = this.props
    if (authenticated && user.sessionId && data)
      this.props.loadEfectores(new Map({
        practiceId: data.id,
        sessionId: user.sessionId
    }))
  }

  render() {
    const { data, handleRemove, handleShowVisitasEfector, efectores, practice_efectores, displayLoadingIndicator, internacion } = this.props
/*
    if (displayLoadingIndicator)
      return (<LoadingIndicator className="text-center" style={{ "marginTop": "15px", "display": "block" }}/>)
*/
    if ( !practice_efectores )
      return null;

    let count = 1;
    console.log(data)
    let isReadOnly = false;
    if (internacion.estado === "C" || data.estado === "C" || data.estado === "R" || (data.fecha_baja && new Date() > new Date(data.fecha_baja)))
      isReadOnly = true;
    let last_efector_id = null;
    let data_table = practice_efectores.items.map( ( item, idx) => {
      count++;
      const nro = idx +1
      last_efector_id = item.efectorId;
      console.log('practice_efectores',item)
      return (
        <Col key={idx} className="col-4 col-md-3 border py-2 px-4">
          <Row>
            <Col className="col-12 col-md-10">
              <Row>
                <Col>
                  <label className="mb-0">Efector { nro }</label>
                  <p className="text-primary mb-2">{ item.efectorNombre + ' ' + item.efectorApellido  }</p>
                </Col>
              </Row>
              <Row>
                <Col className="col-6">
                  <label className="mb-0">Desde</label>
                  <p className="text-primary mb-2">{ item.fechaInicio !== '0001-01-01T00:00:00' && <Moment date={item.fechaInicio} format="DD/MM/YYYY" /> }</p>
                </Col>
                <Col className="col-6">
                  <label className="mb-0">Hasta</label>
                  <p className="text-primary mb-2">{ item.fechaFin !== '0001-01-01T00:00:00' && <Moment date={item.fechaFin} format="DD/MM/YYYY" /> }</p>
                </Col>
              </Row>
            </Col>
            <Col className="col-12 col-md-2 pl-0 pr-0 pt-1 text-right d-flex flex-md-column flex-row-reverse justify-content-end justify-content-md-between">
                   <div className="btn-group-sm btn-group pt-md-1">
                     { !isReadOnly && practice_efectores.total === nro && <button className="btn text-secondary" onClick={ () => handleRemove(item)}><i className="fa fa-trash"></i></button>}
                   </div>
                  <div className="btn-group-sm btn-group pb-md-1">
                    <button className="btn text-info" onClick={ () => handleShowVisitasEfector(item, (idx +1 ), data.id ) }><i className="far fa-user"></i></button>
                  </div>
            </Col>
          </Row>
        </Col>
      )
    })

    console.log('last_efector_id',last_efector_id);
    return (
      <Row>
        {data_table}

        { !isReadOnly &&

        <Col className="col-4 col-md-3 border p-2 d-flex align-items-center justify-content-center" style={{ cursor: 'pointer', minHeight: '110px' }} onClick={ () => this.props.handleShow(data.id, last_efector_id) }>
          <p className="m-0 text-secondary" style={{ fontSize: '15px'}}><i className="fa fa-user-plus mr-2" style={{ fontSize: '24px', verticalAlign: 'bottom'}}></i> Agregar Efector {count}</p>
        </Col>
        }
      </Row>
    );
  }
}

EfectoresList.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string,

};

EfectoresList.defaultProps = {
  title: "Autorización",
  practice_efectores: null
};

//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
  const practice_efectores = getCurrentPracticeEfectores(state, props)
  let isPending = true;
  if (practice_efectores)
    isPending = practice_efectores.isPending
    //console.log('mapStateToProps->',props);
  return {
    user: state.session.user,
    authenticated: state.session.authenticated,
    practice_efectores,
    displayLoadingIndicator: isPending
  };
};

const mapDispatchToProps = {
  loadEfectores: practiceEfectoresActions.loadEfectores
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EfectoresList);
